import {
  CommentStore,
  CompanyContactStore,
  CompanyStore,
  SalesActionStore,
  SalesDealStore,
} from "src/Modules/Company/Stores";
import { AuthStore } from "./Auth.store";
import { UIStore } from "./UI.store";
import { CommonStore } from "./Common.store";
import { CompanyOfficeStore } from "src/Modules/Company/Stores/CompanyOffice.store";
import { MyActionsStore } from "src/Modules/MyActions/Stores/MyActions.store";
import { SettingsStore } from "src/Modules/Settings/Stores/Settings.store";
import { SlaReportingStore } from "src/Modules/Company/Stores/SlaReporting.store";
import { CompanyRevenueStore } from "src/Modules/Company/Stores/CompanyRevenue.store";
import { SLAManagementStore } from "src/Modules/Company/Stores/SLAManagement.store";

export interface IRootStore {
  authStore: AuthStore;
  uiStore: UIStore;
  companyStore: CompanyStore;
  salesDealStore: SalesDealStore;
  salesActionStore: SalesActionStore;
  companyOfficeStore: CompanyOfficeStore;
  companyContactStore: CompanyContactStore;
  addCommentStore: CommentStore;
  myTasksStore: MyActionsStore;
  settingsStore: SettingsStore;
  slaReportingStore: SlaReportingStore;
  companyRevenueStore: CompanyRevenueStore;
  slaManagementStore: SLAManagementStore;
}

export class RootStore implements IRootStore {
  authStore: AuthStore;
  uiStore: UIStore;
  companyStore: CompanyStore;
  commonStore: CommonStore;
  salesDealStore: SalesDealStore;
  salesActionStore: SalesActionStore;
  companyOfficeStore: CompanyOfficeStore;
  companyContactStore: CompanyContactStore;
  addCommentStore: CommentStore;
  myTasksStore: MyActionsStore;
  settingsStore: SettingsStore;
  slaReportingStore: SlaReportingStore;

  constructor() {
    this.authStore = new AuthStore();
    this.uiStore = new UIStore();
    this.companyStore = new CompanyStore(this);
    this.commonStore = new CommonStore(this);
    this.salesDealStore = new SalesDealStore(this);
    this.salesActionStore = new SalesActionStore(this);
    this.companyOfficeStore = new CompanyOfficeStore(this);
    this.companyContactStore = new CompanyContactStore(this);
    this.addCommentStore = new CommentStore(this);
    this.myTasksStore = new MyActionsStore(this);
    this.settingsStore = new SettingsStore(this);
    this.slaReportingStore = new SlaReportingStore(this);
    this.companyRevenueStore = new CompanyRevenueStore(this);
    this.slaManagementStore = new SLAManagementStore(this);
  }
  slaManagementStore: SLAManagementStore;
  companyRevenueStore: CompanyRevenueStore;
}
